import React from 'react';

const Row = (props) => (
    <div className={`row no-gutters ${props.meta.touched && props.meta.error && "form-error"} ${props.visibleIf && "bg-gray"}`}>
        {props.children}
    </div>
);

export default Row;